module.exports = __webpack_public_path__ + "static/media/roundOne.ce0563d1.png";